import React from 'react'
import PropTypes from 'prop-types'
import { HippostdHtml } from './HippostdHtml.jsx'
import RemoteSvg from '../../../common/RemoteSvg.jsx'

const CtiImageCompound = ({
  imageUrl,
  alt,
  title,
  caption,
  classNames,
  imgClasses = 'u-paddingVert2gu',
  downloadUrl = '',
  svgHref = '',
  alignment = 'center',
  svgFallbackUrl = '',
  ...others
}) => {
  function renderImage() {
    if (!imageUrl) return null

    return (
      <img
        className={`${imgClasses}`}
        src={imageUrl}
        alt={alt || title || ''}
      />
    )
  }
  return (
    <>
      {imageUrl ? (
        <div className={`CtiImageCompound ${classNames || ''}`}>
          {title && <h3>{title}</h3>}
          {downloadUrl ? (
            <a href={downloadUrl} target="_blank" rel="noreferrer">
              {renderImage()}
            </a>
          ) : (
            renderImage()
          )}
          {caption && (
            <div>
              <hr className="Rule" role="presentation" />
              <HippostdHtml value={caption} />
            </div>
          )}
        </div>
      ) : null}
      {svgHref && (
        <div className={`CtiImageCompound ${classNames || ''}`}>
          <RemoteSvg
            url={svgHref}
            title={alt}
            alignment={alignment}
            classNames={`u-marginVert4gu ${imgClasses}`}
            fallbackImageUrl={svgFallbackUrl}
            fallbackImageClasses={`${imgClasses}`}
          />
          {caption && (
            <div className={svgFallbackUrl ? '' : 'u-printHidden'}>
              <hr className="Rule" role="presentation" />
              <HippostdHtml value={caption} />
            </div>
          )}
        </div>
      )}
    </>
  )
}

// imageUrl  needs to be set explicitly using
// page.getContent(image.$ref).getOriginal().getUrl()
CtiImageCompound.propTypes = {
  imageUrl: PropTypes.string,
  image: PropTypes.shape({
    $ref: PropTypes.string,
  }),
  alt: PropTypes.string,
  title: PropTypes.string,
  overlay: PropTypes.bool,
  overlayLink: PropTypes.string,
  alignment: PropTypes.string,
  caption: PropTypes.string,
  classNames: PropTypes.string,
  imgClasses: PropTypes.string,
  name: PropTypes.string,
  displayName: PropTypes.string,
  downloadUrl: PropTypes.string,
}

export { CtiImageCompound }
